var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9476 9.17792C27.1695 9.17792 28.9708 7.76128 28.9708 6.01377C28.9708 4.26625 27.1695 2.84961 24.9476 2.84961C22.7256 2.84961 20.9243 4.26625 20.9243 6.01377C20.9243 7.76128 22.7256 9.17792 24.9476 9.17792Z",
    stroke: "#959999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85455 16.5607C11.0765 16.5607 12.8778 15.1441 12.8778 13.3966C12.8778 11.6491 11.0765 10.2324 8.85455 10.2324C6.63257 10.2324 4.8313 11.6491 4.8313 13.3966C4.8313 15.1441 6.63257 16.5607 8.85455 16.5607Z",
    stroke: "#959999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9476 23.9445C27.1695 23.9445 28.9708 22.5279 28.9708 20.7804C28.9708 19.0329 27.1695 17.6162 24.9476 17.6162C22.7256 17.6162 20.9243 19.0329 20.9243 20.7804C20.9243 22.5279 22.7256 23.9445 24.9476 23.9445Z",
    stroke: "#959999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3281 14.9893L21.4877 19.187",
    stroke: "#959999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4743 7.60645L12.3281 11.8042",
    stroke: "#959999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostShare);
export default __webpack_public_path__ + "static/media/PostShare.e1d7647856c369a44dff277a467703d1.svg";
export { ForwardRef as ReactComponent };